<template>
	<div class="Tickets">
		<div class="buttons">
			<vs-button @click="activePrompt = true" color="success"> {{ $t('add') }} </vs-button>
		</div>
		<vx-card class="my-8">
			<div class="tab-text ">
				<vs-table search max-items="10" pagination :data="subjects">
					<template slot="thead">
						<vs-th v-for="fil in field" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="tr[fil.field] !== undefined && tr[fil.field] !== null">
									{{ tr[fil.field] }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
									...
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<vs-prompt
			@cancel="resetCreateForm"
			@accept="createSubject"
			:active.sync="activePrompt"
			:title="$t('addSubject')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
		>
			<div class="con-exemple-prompt">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('name') }} ({{ $t('shortGerman') }})</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="name"
						name="nameDe"
						v-validate="'required|min:3|max:64'"
						@input="resetValidations"
					/>
				</div>
				<span class="text-danger text-sm">
					<span v-if="errors.first('nameDe')">{{ $t('fieldFilledIncorrect') }}</span>
					<span v-else-if="nameExistsError">{{ $t('subjectNameAlreadyExists') }}</span><br>
				</span>
			</div>

			<div class="con-exemple-prompt mt-3">
				<vs-select
					v-model="coefficient"
					v-validate="'required'"
					name="coefficient"
					:label="$t('coefficient')"
					class="w-full"
				>
					<vs-select-item
						v-for="option in coefficientOptions"
						:key="option"
						:value="option"
						:text="String(option)"
					/>
				</vs-select>
				<span class="text-danger text-sm">
					<span v-if="errors.first('coefficient')">{{ $t('fieldFilledIncorrect') }}</span>
				</span>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import notifier from '../mixins/notifier';

export default {
	name: "subjects",
	mixins: [notifier],
	data() {
		return {
			name: '',
			coefficient: '1',
			coefficientOptions: ['1', '1.06', '1.07', '1.1'],
			activePrompt: false,
			nameExistsError: false,
			subjects: [],
			field: [],
		};
	},
	methods: {
		resetValidations() {
			this.nameExistsError = false;
			this.$validator.reset();
		},
		resetCreateForm() {
			this.name = '';
			this.coefficient = '1';
			this.nameExistsError = false;
			this.resetValidations();
		},
		async createSubject() {
			try {
				this.nameExistsError = false;
				this.$validator.resume();
				let validator = await this.$validator.validateAll();
				this.$validator.pause();

				if (!validator) return this.activePrompt = true;
				let formData = {
					"name_de": this.name.trim(),
					"coefficient": this.coefficient,
				}

				await this.$http.post("/admin/subject/create", formData);

				this.notifySuccess(this.$t('addedSuccessfully'));
				this.resetCreateForm();
				this.getSubjects();

			} catch (e) {
				const apiErrors = e.response && e.response.data && e.response.data.errors;
				const isDuplicateName = apiErrors && apiErrors.nameDe;
				this.nameExistsError = !!isDuplicateName;
				this.notifyError(isDuplicateName ? this.$t('subjectNameAlreadyExists') : (e.message || this.$t('fieldFilledIncorrect')));
				this.activePrompt = true;
			}
		},
		async getSubjects() {
			try {
				this.subjects = (
					await this.$http.get("/admin/subject")).data.data;
			} catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	created() {
		this.field = [
			{
				field: "name_ru",
				title: `${this.$t('name')} (${this.$t('shortRussian')})`,
				align: 'center',
			},
			{
				field: "name_de",
				title: `${this.$t('name')} (${this.$t('shortGerman')})`,
				align: 'center',
			},
			{
				field: "coefficient",
				title: this.$t('coefficient'),
				align: 'center',
			},
		];
	},
	async mounted() {
		this.$validator.pause();
		await this.getSubjects();
	},
};
</script>

<style lang="scss">
@import "../assets/scss/vuexy/variables.scss";

.Tickets {
	.buttons {
		display: flex;
		justify-content: flex-end;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}
}
.justify-center .vs-table-text{
	justify-content: center;
}
.con-exemple-prompt {
	.vs-input {
		width: 100%;
	}
	.vs-input--label {
		display: block;
		margin-bottom: 6px;
		font-size: 0.85rem;
	}
}
</style>
